import type {Variant} from 'motion';

export const ModalEnterExitAnimation: {enter: Variant; exit: Variant} = {
    enter: {
        opacity: 1,
        x: '-50%',
        y: '-50%'
    },
    exit: {
        opacity: 0,
        x: '-50%',
        y: 'calc(-50% - 80px)'
    }
};